<template>
  <div class="center" id="tablaFiltros">
<!-- {{ dataRowsFilter }} -->
<!-- {{ status }} -->
    <vs-table v-model="selected" >
      <template #header>
        <div class="d-flex justify-content-between pt-2" v-if="showSearch">
          <div>
              <vs-select label="Mostrar" placeholder="Filter" v-model="max" v-if="showPagination">
                  <vs-option v-for="numero,index in listaMostrar" :key="index" :label="numero" :value="numero">{{numero}}</vs-option>
              </vs-select>
          </div>
          <div>
            <vs-input label="Buscar" vs-type="flex" type="search" v-model="search" border />
          </div>
      </div>
      </template>
      <template #thead>
        <vs-tr>
          <vs-th v-if="checkAllRows">
            <vs-checkbox 
              :indeterminate="selected.length == dataRows.length" v-model="allCheck" :color="$status_3"
              @change="$emit('select-all')"
            />
          </vs-th>
          <vs-th v-for="(column,index) in dataColumns" :key="index">
            {{column.columnName}}
            <vs-button class="transparent" @click="$emit('table-sort',$event, column.columnProperty)" size="mini" v-if="column.sort">
                <font-awesome-icon icon="fa-solid fa-sort" />
            </vs-button>
            <px-table-filter 
              v-if="column.filter" 
              :indexColumn="index" 
              :dataList="[...new Set(dataRows.map(x => x[column.columnProperty] ))]" 
              :dataRowFilter="column.rowsFilter"
              :name="column.columnName"
            />
             <!-- @set-filter-data="handleDataRowsFilterColumn" -->
          </vs-th>
        </vs-tr>
      </template>
      <template #tbody v-if="showSearch">
        <vs-tr
          :key="i"
          v-for="(tr, i) in $vs.getSearch(dataRowsFilter, search)"
          :data="tr"
          :is-selected="!!selected.includes(tr)"
          not-click-selected
          open-expand-only-td
          :class="status==''? '' : colors(tr[`${status}`])"
        >
          <vs-td checkbox v-if="checkAllRows">
            <vs-checkbox :val="tr" :color="$tertiary" v-model="selected" />
          </vs-td>
          <vs-td v-for="(td,index) in dataColumns" :key="td.columnProperty+index" :style="{width: td.width + '%'}">
            <slot name="cell" :property="td.columnProperty" :type="td.type" :value="tr"></slot>
          </vs-td>

          <template #expand v-if="expand">
            <div class="con-content">
              <slot name="expand" :value="tr">
              </slot>
            </div>
          </template>

        </vs-tr>
        
      </template>
      <template #tbody v-else>
        <vs-tr
          :key="i"
          v-for="(tr, i) in $vs.getPage($vs.getSearch(dataRowsFilter, search), page, max)"
          :data="tr"
          :is-selected="!!selected.includes(tr)"
          not-click-selected
          open-expand-only-td
          :class="status==''? '' : colors(tr[`${status}`])"
        >
          <vs-td checkbox v-if="checkAllRows">
            <vs-checkbox :val="tr" :color="$tertiary" v-model="selected" />
          </vs-td>
          <vs-td v-for="(td,index) in dataColumns" :key="td.columnProperty+index" :style="{width: td.width + '%'}">
            <slot name="cell" :property="td.columnProperty" :type="td.type" :value="tr"></slot>
          </vs-td>

          <template #expand v-if="expand">
            <div class="con-content">
              <slot name="expand" :value="tr">
              </slot>
            </div>
          </template>

        </vs-tr>
        
      </template>
      <template #footer v-if="showPagination">
        <vs-pagination v-model="page" :length="$vs.getLength($vs.getSearch(dataRowsFilter, search), max)" />
      </template>
    </vs-table>
  </div>
</template>
<script>
  import PxTableFilter from '@/components/table/components/PxTableFilter.vue'
  export default {
    name:'TableGeneric',
    components:{PxTableFilter},
    props:{
      ConfigurationColorStatus:{
          default: () => [],
          type: Array
      },
      status:{
        default: '',
          type: String
      },

      dataRows: {
        default: () => [],
        type: Array
      },
      dataColumns: {
        default: () => [],
        type: Array
      },
      selected: {
        default: () => [],
        type: Array
      },
      checkAllRows: {
        default : false,
        type: Boolean
      },
      expand: {
        default: false,
        type: Boolean
      },
      maxNumber: {
        default: 10,
        type: Number
      },
      showSearch: {
        default: true,
        type: Boolean
      },
      showPagination: {
        default: false,
        type: Boolean
      }
    },
    data:() => ({
      editActive: false,
      edit: null,
      editProp: {},
      search: '',
      allCheck: false,
      page: 1,
      max: 10,
      active: 0,
      dataFilter:[],
      listaMostrar:[5,10,25,50,100]
    }),
    methods:{
      colors(value){
        if(this.ConfigurationColorStatus.find( x => x.value==value )) return this.ConfigurationColorStatus.find( x => x.value==value ).colorClass
        else return '';
      },
      // handleDataRowsFilterColumn(data,index){
      //   if(data && index >= 0){
      //     this.dataColumns[index].rowsFilter = [...data]
      //   }
      // },
      filtroLista(row){

        const LIST_FILTER = [...this.dataColumns.filter(x => x.filter == true)]
        const NUMBER_FILTER = LIST_FILTER.length
        
        if(NUMBER_FILTER == 0){return true} 

        let numberFilterRow = 0
        
        for(const column in LIST_FILTER){
          if(LIST_FILTER[column].rowsFilter<=0) {
            numberFilterRow++
          }else if(row[LIST_FILTER[column].columnProperty]){        
            let exist = LIST_FILTER[column].rowsFilter.some(filterElement => filterElement === row[LIST_FILTER[column].columnProperty])
            if(exist) numberFilterRow++
          }
        }

        return NUMBER_FILTER == numberFilterRow ? true : false
        
        //Buscar solo Seleccionados
        // let numberFilter = this.dataColumns.filter(x=> x.filter == true).length
        // if(numberFilter==0){
        //   return true
        // } 

        // let numberFilterRow = 0

        // for(let column in this.dataColumns.filter(x=> x.filter == true)){    
        //   if(row[this.dataColumns[column].columnProperty]){
        //     let exist = this.dataColumns[column].rowsFilter.some(filterElement => filterElement == row[this.dataColumns[column].columnProperty])
        //     if(exist) numberFilterRow++
        //   }
        // }
        // return numberFilter == numberFilterRow ? true : false
      },
      getRowData(){

      }
    },
    computed:{
      dataRowsFilter(){
        return this.dataRows.filter( row =>  this.filtroLista(row) )
      }
    },
    created(){
      // this.filterRows = this.dataRows

      //Buscar solo Seleccionados
      // for(let column in this.dataColumns.filter(x=> x.filter == true)){    
      //     this.dataColumns[column].rowsFilter = [...new Set(this.filterRows.map(x => x[this.dataColumns[column].columnProperty] ))]
      //   }
    },
    mounted(){
      this.max = this.maxNumber
    }
  }
  </script>
<style scoped>
.vs-table__td { padding: 2px 12px; }
.vs-table__th { width: 0px !important; }
</style>